import React, { useRef, useEffect, useState } from 'react';
import CourseModal from './course-modal-component';
import Tooltip from '../Utils/Tooltip/tooltip-component';
import './overlapping-course-styles.css';


const OverlappingCards = ({ courses ,trigger }) => {
    const containerRef = useRef(null);
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (containerRef.current) {
                setScrollY(containerRef.current.scrollTop);
            }
        };

        const container = containerRef.current;
        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, []);

    // Adjust style based on scrollY
    const getCardStyle = (index) => {
        const cardHeight = 400; // Adjust based on your card's height
        const initialOffset = 0; // Initial vertical space between cards
        let topOffset = initialOffset + index * cardHeight - scrollY;
        let zIndex = 40 - Math.abs(courses.length-index); // Higher z-index for cards at the top

        return { top: `${topOffset}px`, zIndex: zIndex };
    };

     return (
        <div className="card-container rounded-2xl my-2 snap-y snap-mandatory overflow-auto" ref={containerRef}>
            {courses.map((card, index) => (
                <div key={index} className="w-full mt-10 snap-center" style={getCardStyle(index)}>
                    <CourseModal id={index} course={card} isVisible={true} trigger={trigger} totalCourses={courses.length}/>
                </div>
            ))}
        </div>
    );
};

export default OverlappingCards;
